<template>
  <div  class="uv-card">
    <div class="uv-card-body">
      <ModuleHeader>Tipos de CreditBooks</ModuleHeader>
      <uv-data-table
        :config="config"
        :data="cbList"
        :pageRows="15"
        @buttonClick="dtButtonClick"
      ></uv-data-table>
    </div>
    <modal v-model="showModal" :showFooter="false" title="Agregar tipo CreditBook">
      <CreditBooksTypeForm
        :edit="editMode"
        :key="formIndex"
        @toggle="toggleModal"
        :dataEdit="editData"
        @successData="successData"
      >
      </CreditBooksTypeForm>
    </modal>
  </div>

  
</template>



<script>
import uvDataTable from "../MainComponents/DataTable.vue";
import CreditBooksTypeForm from "./CreditBooksTypeForm.vue"
import { mapGetters } from "vuex";
export default {
  name: "CreditBooksType",
  components: {
    uvDataTable,
    CreditBooksTypeForm
  },
  props:['membresia_id'],
  data() {
    return {
      formIndex: 0,
      cbList:[],
      editMode: false,
      editData: {},
      indexComponent: 1,
      showModal: false,
      config: {
        selectableRow: true,
        allowExport: true,
        rawText: "Tipos CreditBook",
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        orderByCol:{Field:"",Type:"Asc"},
        buttons: [
            {
            text: "Agregar",
            icon: "lni lni-plus",
            buttonId: "addTipoCB",
          },
          /*{
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editarTipoCB",
            require: true,
          },
          {
            text: "Eliminar",
            icon: "lni lni-trash",
            buttonId: "deleteTipoCB",
            require: true,
          },*/
        ],
        fields: [
          {
            text: "Nombre",
            value: "nm",
          },
          {
            text: "Metodo Pago",
            value: "mp",
          },
        ],
      },
      fullAccess: false,
      idSelected: "",
    };
  },
  computed: {
    ...mapGetters([ "getPDVPagosTipos", "getPDVMonedasLista"]),
  },
  methods: {

    successData(data, doAction) {
      if (doAction == "CREATE") {
        this.createTipoCreditBook(data);
      }else{
        this.updateTipoCreditBook(data)
      }
    },
    dtButtonClick(buttonId, idSelected) {
      this.formIndex++;
      if (buttonId == "addTipoCB") {
        this.idSelected = "";
        this.editMode = false;
        this.editData = {};
        //this.$refs.modalForm.setTitle("Agregar MetodoPago");
        this.toggleModal(true);
      }
      if (buttonId == "editarTipoCB") {
        this.idSelected = idSelected[0];
        const mp = this.$pgsHelper.getById(
          this.getPDVPagosTipos,
          "id",
          idSelected[0]
        );
        
        this.editMode = true;
        this.editData = mp;
        
        this.toggleModal(true);
      }
      if (buttonId == "deleteTipoCB") {
        const mp = this.$pgsHelper.getById(
          this.getPDVPagosTipos,
          "id",
          idSelected[0]
        );
        this.deleteMp(idSelected[0]);
      }
    },
    async getTiposCb(){
      const data =
        await this.$store.getters.getFirebaseApp.database.queryBuilder(
          "PDV/TiposDineroElectronico"
        );
      this.cbList = this.$pgsHelper.ArrayObjectToArray(data.val());
    },
    createTipoCreditBook(data) {
      if(data.cb){
        data.Id = "CB_"+data.Id 
      }
      this.$swal({
        title: "¿Deseas guardar el tipo de CreditBook?",
        text: "",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("PDV-TipoDineroElectronico-crearTipoDineroElectronico", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "El tipo de CreditBook se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
            });
          } else {
            this.$swal(
              "Error saving metodo pago",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    updateTipoCreditBook(data) {
      this.$swal({
        title: "¿Deseas editar el tipo de CreditBook?",
        text: "",
        icon: "warning",
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Guardar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("GBL-MetodoPago-updateMetodoPago", data)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          this.$emit("reloadClient");
          if (result.value.data.ok) {
            this.$swal({
              title: "Guardado",
              text: "El Metodo de pago se guardo correctamente",
              icon: "success",
            }).then(() => {
              this.toggleModal(false);
            });
          } else {
            this.$swal(
              "Error saving metodo pago",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    deleteMp(id) {
      let datos = { Id: id };
      this.$swal({
        title: "¿Deseas eliminar este tipo de CreditBook?",
        text: "Se eliminara permanentemente",
        icon: "warning",
        showCancelButton: true,
        allowOutsideClick: false,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Eliminar",
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("GBL-MetodoPago-deleteMetodoPago", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal("El tipo de CreditBook se elimino correctamente", "", "success");
            //this.getClientes();
            this.$forceUpdate();
          } else {
            this.$swal(
              "Error eliminando datos",
              result.value.data.error,
              "error"
            );
          }
        }
      });
    },
    toggleModal(open) {
      this.showModal = open;
    },
  },
  beforeMount: function () {},
  mounted: async function () {
    await this.getTiposCb()
  },
};
</script>